<div *ngIf="sectionVisible" class="information-clause power-of-attorney">
  <div class="information-clause__wrapper">
    <span [innerHTML]="agreementText | safeHtml"></span>
  </div>
</div>
